// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__B1opR","productName":"Table_productName__37xdC"};